import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import Close from '../Icons/Close';

type Props = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
  value: string;
};

const SearchInput = ({ onChange, value, onClear }: Props) => {
  const { t } = useTranslation('common');

  return (
    <div className="relative m-4 flex h-12 items-center">
      <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3">
        <Image src="/magnifying_glass.svg" alt="magnifying_glass" width={17} height={17} />
      </div>
      <input
        type="text"
        id="hotel-search"
        className="block w-full border-gray-100 bg-gray-50 p-4 pe-12 ps-10 text-base outline-none"
        placeholder={t('search_header.search_hotel_placeholder')}
        onChange={onChange}
        value={value}
        autoComplete="off"
      />
      {value && (
        <div className="absolute inset-y-0 end-4 flex items-center justify-center">
          <button
            className="flex size-8 items-center justify-center"
            type="button"
            onClick={onClear}
            aria-label="Clear search"
          >
            <Close size={16} />
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchInput;
